import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import type { OnboardingChecklist } from '../models/onboarding-checklist.model';

@Injectable({ providedIn: 'root' })
export class OnboardingChecklistApiService {
  private readonly http = inject(HttpClient);

  getChecklist(): Observable<OnboardingChecklist> {
    return this.http.get<OnboardingChecklist>('/api/onboarding/checklist');
  }

  dismiss(): Observable<OnboardingChecklist> {
    return this.http.post<OnboardingChecklist>('/api/onboarding/checklist/dismiss', {});
  }
}
